export const groupTypes = {
    KIDS_PREMIUM_PRESCHOOL: 'Kids Premium Preschool',
    KIDS_PREMIUM_STARTER: 'Kids Premium Starter',
    TEENS_PREMIUM: 'Teens Premium kurs',
    CAMBRIDGE_PREMIUM: 'Cambridge Premium kurs',
    KIDS_PREMIUM_ELEMENTARY: 'Kids Premium Elementary', 
    INDIVIDUALNI_KIDS_PREMIUM_PRESCHOOL: 'Individualni Kids Premium Preschool kurs',
    INDIVIDUALNI_KIDS_PREMIUM_STARTER: 'Individualni Kids Premium Starter kurs',
    INDIVIDUALNI_KIDS_PREMIUM_ELEMENTARY: 'Individualni Kids Premium Elementary kurs',
    INDIVIDUALNI_TEENS_PREMIUM: 'Individualni Teens Premium kurs',
    INDIVIDUALNI_CAMBRIDGE_PREMIUM: 'Individualni Cambridge Premium kurs', 
    POPRAVI_SVOJU_OCENU: 'Kurs „Popravi svoju ocenu”',
    LETNJI_JEZICKI_KAMP: 'Letnji jezički kamp',
    ZIMSKI_JEZICKI_KAMP: 'Zimski jezički kamp',
    DOPUNSKI_PREDSKOLSKI_PROGRAM: 'Dopunski predškolski program',
    VIKEND_JEZICKI_KAMP: 'Vikend jezički kamp',
};